var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3V25.5283C0 27.1852 1.34315 28.5283 3 28.5283H33C34.6569 28.5283 36 27.1852 36 25.5283V6.89887C36 5.24201 34.6569 3.89887 33 3.89887H17.9209C16.7487 3.89887 15.6993 3.20224 15.0353 2.23626C14.3064 1.176 13.2297 0 12.0393 0H2.9976C1.34075 0 0 1.34314 0 3Z",
    fill: "#30C584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8.24405V25.7183C36 27.2702 34.7419 28.5283 33.19 28.5283H2.81C1.25808 28.5283 0 27.2702 0 25.7183V10.1665C0 8.61461 1.25683 7.35653 2.80875 7.35653H11.4031C14.6073 7.35653 14.1597 5.43386 16.3508 5.43396C21.8652 5.43422 29.2318 5.43412 33.1942 5.43403C34.7461 5.434 36 6.69209 36 8.24405Z",
    fill: "url(#paint0_linear_217_420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_420",
    x1: 36,
    y1: 5.43396,
    x2: 0.616611,
    y2: 29.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#7DF7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30C584"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c486edd647b44a800f6aaa41a6663c6f.svg";
export { ForwardRef as ReactComponent };